import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Busonrentinhadapsarpune() {



const cardData =
  {
    keyword: 'Bus On Rent in Hadapsar Pune',
    heading: 'Sanavi Travels: Bus On Rent in Hadapsar Pune',
    headingDescription: 'Sanavi Travels offers reliable, professionally managed, and affordable Bus On Rent in Hadapsar Pune, catering to families, corporate teams, IT employees, schools, colleges, wedding groups, picnic travelers, and outstation passengers. Hadapsar is one of the fastest-growing commercial and residential hubs in Pune, known for its IT parks, industrial estates, educational institutions, shopping centers, and excellent connectivity to Magarpatta City, SP Infocity, Pune–Solapur Road, and major highways. Due to daily office commutes, corporate events, weddings, school trips, social functions, and frequent outstation travel, the demand for organized group transportation in Hadapsar is consistently high. To meet these diverse requirements, Sanavi Travels provides a wide fleet of AC buses, Non-AC buses, luxury coaches, mini buses, and large seating-capacity buses suitable for city travel as well as long-distance journeys. Each bus is maintained with clean interiors, comfortable cushioned seating, smooth suspension, proper ventilation, and ample luggage space to ensure a safe and relaxed journey even in city traffic.',

    top: 'Top Places to Visit in and Around Hadapsar with Sanavi Travels',


"topPlaces": [
  {
    "title": "Hadapsar City Area",
    "description": "Hadapsar is a major residential and commercial zone in Pune, hosting IT professionals, business owners, students, and families. Daily group movement for offices, institutions, events, and social functions is common. Bus rentals help manage organized transportation across busy city roads while reducing congestion and coordination issues."
  },
  {
    "title": "Magarpatta City",
    "description": "Magarpatta City is a prominent IT and business hub near Hadapsar, attracting thousands of employees daily. Corporate teams often require buses for office commutes, meetings, training programs, and team outings. Bus hire services ensure punctual, safe, and professional group travel."
  },
  {
    "title": "SP Infocity",
    "description": "SP Infocity is another major IT park near Hadapsar with frequent corporate activity. Companies rely on bus rentals for employee transportation, corporate events, audits, and client visits, ensuring organized movement and time efficiency."
  },
  {
    "title": "Amanora and Seasons Mall",
    "description": "Shopping malls like Amanora Mall and Seasons Mall attract families, college groups, and tourists. Bus rentals are ideal for group shopping trips, school excursions, and social outings without parking hassles."
  },
  {
    "title": "Educational Institutions",
    "description": "Hadapsar and nearby areas host multiple schools, colleges, and coaching centers. Educational tours, competitions, industrial visits, and cultural programs generate regular demand for safe and punctual bus transportation."
  },
  {
    "title": "Wedding and Event Venues",
    "description": "Hadapsar has several marriage halls, banquet venues, and open lawns used for weddings and social events. Hiring buses helps families manage guest transportation efficiently while avoiding traffic and parking issues."
  },
  {
    "title": "Pune–Solapur Road",
    "description": "The Pune–Solapur Road passes through Hadapsar and serves as a major highway for outstation travel. Bus rentals provide a smooth and cost-effective option for long-distance journeys starting from Hadapsar."
  },
  {
    "title": "Corporate and Business Travel",
    "description": "Business owners and professionals from Hadapsar frequently travel to other parts of Pune and nearby cities for meetings and events. Bus hire services provide organized and comfortable group transport."
  },
  {
    "title": "Picnic and Leisure Destinations",
    "description": "Schools, offices, and families from Hadapsar plan picnics and leisure trips to nearby destinations. Bus rentals ensure safe, enjoyable, and coordinated travel for such outings."
  },
  {
    "title": "Outstation Travel Routes",
    "description": "Hadapsar acts as a convenient starting point for outstation travel to Mumbai, Solapur, Satara, Kolhapur, and other destinations. Bus rentals offer comfort, safety, and affordability for long-distance group journeys."
  }
]
,



"services": [
{
"name": "Bus On Rent in Hadapsar Pune",
"description": "Bus On Rent in Hadapsar Pune provides reliable, spacious, and professionally managed buses for corporate travel, weddings, school trips, picnics, social events, and outstation journeys. Our buses are designed for city traffic as well as highway travel, featuring clean interiors, comfortable cushioned seating, smooth suspension, proper ventilation, and ample luggage space. Experienced drivers familiar with Hadapsar roads, IT parks, residential areas, and highways ensure punctual pickups, disciplined driving, and smooth coordination. This service is ideal for families, offices, institutions, and organizations looking for stress-free group transportation in Pune."
},
{
"name": "Bus Hire Hadapsar Pune",
"description": "Bus Hire Hadapsar Pune offers flexible rental options for local travel, full-day bookings, corporate usage, and long-distance trips. With well-maintained buses and trained drivers, group travel becomes safe, economical, and well organized."
},
{
"name": "AC Bus Rental Hadapsar",
"description": "AC Bus Rental Hadapsar provides air-conditioned comfort for summer travel and long journeys, reducing fatigue and ensuring a pleasant travel experience for passengers."
},
{
"name": "Non AC Bus on Rent Hadapsar",
"description": "Non AC Bus on Rent Hadapsar is a budget-friendly option suitable for short city routes, school trips, local events, and economical group travel without compromising safety."
},
{
"name": "Luxury Bus on Rent Hadapsar Pune",
"description": "Luxury Bus on Rent Hadapsar Pune delivers a premium travel experience with superior interiors, enhanced seating comfort, and professional presentation, ideal for weddings, VIP guests, and corporate executives."
},
{
"name": "Mini Bus Hire Hadapsar",
"description": "Mini Bus Hire Hadapsar is perfect for small to medium-sized groups such as office teams, families, and students, offering flexibility, affordability, and easy maneuverability in city traffic."
},
{
"name": "32 Seater Bus on Rent Hadapsar",
"description": "32 Seater Bus on Rent Hadapsar is ideal for school excursions, corporate outings, and medium-sized group travel, balancing seating capacity with comfort."
},
{
"name": "35 Seater Bus Hire Hadapsar",
"description": "35 Seater Bus Hire Hadapsar supports large group transportation needs such as weddings, corporate events, political programs, and long-distance tours."
},
{
"name": "Bus on Rent Hadapsar for Wedding",
"description": "Bus on Rent Hadapsar for Wedding ensures smooth and coordinated transportation for wedding guests, helping families manage large gatherings without travel stress."
},
{
"name": "Bus on Rent Hadapsar for Corporate",
"description": "Bus on Rent Hadapsar for Corporate provides structured and professional transport for office commutes, meetings, conferences, plant visits, and employee engagement programs."
},
{
"name": "Bus on Rent Hadapsar for Picnic",
"description": "Bus on Rent Hadapsar for Picnic offers safe and enjoyable group travel for schools, offices, and families planning leisure and educational outings."
},
{
"name": "Bus Rental Hadapsar Outstation",
"description": "Bus Rental Hadapsar Outstation provides dependable long-distance transportation to Mumbai, Solapur, Satara, Kolhapur, and other destinations."
},
{
"name": "Bus Hire Hadapsar with Driver",
"description": "Bus Hire Hadapsar with Driver offers chauffeur-driven buses where experienced drivers manage routes, traffic, and schedules professionally."
},
{
"name": "Affordable Bus Rental Hadapsar Pune",
"description": "Affordable Bus Rental Hadapsar Pune delivers cost-effective transportation solutions without compromising cleanliness, comfort, or reliability."
},
{
"name": "Best Bus Service Hadapsar",
"description": "Best Bus Service Hadapsar is trusted for punctual service, clean buses, transparent pricing, and customer satisfaction delivered by Sanavi Travels."
}
],
"tableData": [
["Bus On Rent in Hadapsar Pune", "Bus Hire Hadapsar Pune"],
["AC Bus Rental Hadapsar", "Non AC Bus Hire Hadapsar"],
["Luxury Bus Hadapsar", "Mini Bus Hire Hadapsar"],
["32 Seater Bus Hadapsar", "35 Seater Bus Hadapsar"],
["Wedding Bus Hadapsar", "Corporate Bus Hadapsar"],
["Picnic Bus Hadapsar", "Outstation Bus Hadapsar"],
["Bus Hire Hadapsar with Driver", "Affordable Bus Rental Hadapsar"],
["Best Bus Service Hadapsar", "—"]
]
,


"whychoose": [
  {
    "WhyChooseheading": "Bus On Rent in Hadapsar Pune with Sanavi Travels",
    "WhyChoosedescription": "Sanavi Travels offers reliable and professional bus rental services in Hadapsar for all group travel needs."
  },
  {
    "WhyChooseheading": "City and Highway Route Expertise",
    "WhyChoosedescription": "Drivers are familiar with Hadapsar roads, IT parks, highways, and outstation routes."
  },
  {
    "WhyChooseheading": "Clean and Comfortable Fleet",
    "WhyChoosedescription": "All buses are regularly serviced and cleaned to ensure passenger comfort."
  },
  {
    "WhyChooseheading": "Transparent Pricing",
    "WhyChoosedescription": "Clear pricing structure with no hidden charges."
  },
  {
    "WhyChooseheading": "24/7 Customer Support",
    "WhyChoosedescription": "Round-the-clock assistance for bookings and travel coordination."
  },
  {
    "WhyChooseheading": "Flexible Rental Options",
    "WhyChoosedescription": "Hourly, full-day, corporate, and outstation rental plans available."
  },
  {
    "WhyChooseheading": "Safe and Sanitized Vehicles",
    "WhyChoosedescription": "Buses are sanitized before every trip for passenger safety."
  },
  {
    "WhyChooseheading": "Reliable and On-Time Service",
    "WhyChoosedescription": "Guaranteed punctual pickups and smooth journey management."
  }
]

}

const faqData = [
  {
    question: 'Does Sanavi Travels provide bus rental services in Hadapsar Pune?',
    answer: 'Yes, Sanavi Travels offers reliable bus rental services in Hadapsar Pune.'
  },
  {
    question: 'What types of buses are available in Hadapsar?',
    answer: 'AC buses, Non AC buses, mini buses, luxury buses, 32-seater and 35-seater buses are available.'
  },
  {
    question: 'Is bus rental available for corporate and weddings?',
    answer: 'Yes, we provide dedicated buses for corporate travel, weddings, and social events.'
  },
  {
    question: 'Can I book a bus for outstation travel from Hadapsar?',
    answer: 'Yes, outstation bus rentals are available from Hadapsar.'
  },
  {
    question: 'Are the buses sanitized?',
    answer: 'Yes, all buses are sanitized before every journey.'
  }
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Sandeep Kulkarni',
    feedback: 'We hired a bus from Hadapsar for a corporate outing. Very professional and punctual service.',
    rating: 5
  },
  {
    id: 2,
    name: 'Ms. Priyanka Deshmukh',
    feedback: 'Sanavi Travels provided a clean and comfortable bus for our wedding guests from Hadapsar.',
    rating: 5
  }
];





















  const Images = [
    { place: "/images/keyword/1.jpg", text: "Tempo Traveller On Rent in Pune", link: "tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/2.jpg", text: "Pune to Shirdi Tempo Traveller On Rent", link: "pune-to-shirdi-tempo-traveller-on-rent" },
    { place: "/images/keyword/3.jpg", text: "Pune to Mahabaleshwar Tempo Traveller on Rent", link: "pune-to-mahabaleshwar-tempo-traveller-on-rent" },
    { place: "/images/keyword/4.jpg", text: "Pune to Goa Tempo Traveller Hire", link: "pune-to-goa-tempo-traveller-hire" },
    { place: "/images/keyword/5.jpg", text: "Pune to Mumbai Tempo Traveller on Rent", link: "pune-to-mumbai-tempo-traveller-on-rent" },
    { place: "/images/keyword/6.jpg", text: "Pune to Konkan Darshan Tempo Traveller Hire", link: "pune-to-konkan-darshan-tempo-traveller-hire" },
    { place: "/images/keyword/7.jpg", text: "Pune to Nashik Tempo Traveller On Rent", link: "pune-to-nashik-tempo-traveller-on-rent" },
    { place: "/images/keyword/8.jpg", text: "Tempo Traveller On Rent for Pune Darshan", link: "tempo-traveller-on-rent-for-pune-darshan" },
    { place: "/images/keyword/9.jpg", text: "Mini Bus On Rent in Pune", link: "mini-bus-on-rent-in-pune" },
    { place: "/images/keyword/10.jpg", text: "13 Seater Tempo Traveller On Rent in Pune", link: "13-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/11.jpg", text: "17 Seater Tempo Traveller on Rent in Pune", link: "17-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/12.jpg", text: "20 Seater Luxury Bus On Rent Pune", link: "20-seater-luxury-bus-on-rent-pune" },
    { place: "/images/keyword/13.jpg", text: "26 Seater Tempo Traveller On Rent in Pune", link: "26-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/14.jpg", text: "32 Seater Luxury Bus On Rent in Pune", link: "32-seater-luxury-bus-on-rent-in-pune" },
    { place: "/images/keyword/15.jpg", text: "35 Seater Bus on Rent in Pune", link: "35-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/16.jpg", text: "45 Seater Bus On Rent in Pune", link: "45-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/17.jpg", text: "50 Seater Bus On Rent in Pune", link: "50-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/18.jpg", text: "Bus Hire for School Trips in Pune", link: "bus-hire-for-school-trips-in-pune" },
    { place: "/images/keyword/19.jpg", text: "Bus booking for Wedding in Pune", link: "bus-booking-for-wedding-in-pune" },
    { place: "/images/keyword/20.jpg", text: "Bus Booking for Marriage in Pune", link: "bus-booking-for-marriage-in-pune" },
    { place: "/images/keyword/21.jpg", text: "Bus Service for Corporate in Pune", link: "bus-service-for-corporate-in-pune" },
    { place: "/images/keyword/22.jpg", text: "Bus on Rent For Event in Pune", link: "bus-on-rent-for-event-in-pune" },
    { place: "/images/keyword/23.jpg", text: "Bus Hire for Outstation in Pune", link: "bus-hire-for-outstation-in-pune" },
    { place: "/images/keyword/24.jpg", text: "AC Bus On Rent in Pune", link: "ac-bus-on-rent-in-pune" },
    { place: "/images/keyword/25.jpg", text: "Pune Bus Hire Rental Service", link: "pune-bus-hire-rental-service" },
  ];








const jsonData = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Bus On Rent in Hadapsar Pune - Sanavi Travels",
  "description": "Sanavi Travels offers bus on rent in Hadapsar Pune for weddings, corporate travel, picnics, and outstation trips. We provide AC and Non-AC buses, luxury buses, mini buses, 32 seater and 35 seater buses with professional drivers at affordable rates.",
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.7",
    "ratingCount": "10000+"
  }
};







  return (
    <div>


<Helmet>
  <title>
    Call : +91 7387507373 | Bus On Rent in Hadapsar Pune | Sanavi Travels
  </title>

  <meta
    name="description"
    content="Book bus on rent in Hadapsar Pune with Sanavi Travels. AC & Non-AC buses, luxury and mini bus rental for weddings, corporate travel, picnics, and outstation trips with driver at best prices."
  />

  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>

      <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box text-white">
                <h1 className="text-anime-style-3 text-center text-white" data-cursor="-opaque">
                  <h3> {cardData.keyword}</h3>
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>





      <section>
        <div className="container-fluid" >
          <div className="row container-fluid p-0">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/238.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>



              <div className="shambhu-services">
                {cardData.services.map((service, index) => (
                  <div key={index} className="sh-service-card">

                    <div className="sh-service-left">
                      <div className="sh-service-icon">
                        🚖
                      </div>
                    </div>

                    <div className="sh-service-content">
                      <h4 className="sh-service-title">{service.name}</h4>
                      <p className="sh-service-desc">{service.description}</p>
                    </div>

                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Sanavi Travels </span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Sanavi Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+917387507373" className="pc-call">+91 7387507373</a>
                      <a href="tel:+919595532929" className="pc-call">+91 9595532929</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/917387507373"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+917387507373" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@sanavitravels.com" className="pc-email">
                      booking@sanavitravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Sanavi Travels</strong><br />
                      OFFICE NO.6, GROUND FLOOR GAT NO.1110,
                      SHREE GOPINATH MAHARAJ VYAPARI SHED SHIVAJI CHOWK, VARVAND TAL DAUND,
                      DIST PUNE – 412215
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Busonrentinhadapsarpune;